import mainLogo from '../../images/Globo/globo_logo_main_color.png';
import squareLogo from '../../images/Globo/globo_logo_square_color.png';
import squareLogoSmall from '../../images/Globo/globo_logo_square_small_color.png';
import mainLogoWhite from '../../images/Globo/globo_logo_main_white.png';
import banner01 from '../../images/Globo/globo_banner_01.webp';
import banner02 from '../../images/Globo/globo_banner_02.webp';
import banner03 from '../../images/Globo/globo_banner_03.webp';
import car123 from '../../images/Globo/123_compass.jpg';
import box123 from '../../images/Globo/123_globo.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Globo',
    defaultStoreLink: 'loja.grupoglobo.com.br',
    defaultContactEmail: 'e-commerce@grupoglobo.com.br',
    whatsappNumber: '41 9911 0733',
    CNPJ: '52.181.468/0001-23',
    CNPJname: '',
    CNPJaddress: '',
    launchDate: '18/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "ford",
        "jeep",
        "nissan",
        "renault",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Globo Veículos Alto da XV",
        "GLOBO JEEP CURITIBA",
        "Globo Veículos São José dos Pinhais",
        "Globo Veículos Água Verde",
        "Globo Nissan Alto da XV",
        "Globo Nissan Torres",
        "GLOBO RENAULT SC",
        "GLOBO JEEP SC",
        "GLOBO FORD SC",
        "GLOBO FIAT SC",
        "GLOBO NISSAN SC", //Concessionária Nissan - Florianópolis SC
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogoSmall,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner03,
    banner03: '',
    bannerBrands: '',
    aboutUsBg: banner02,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias do <mark>Grupo Globo</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo Globo com mais de 38 anos no mercado automobilístico mantém sua referência em qualidade, variedade e comodidade na realização dos sonhos de nossos clientes.',
            'Amplo atendimento com grandes marcas como Fiat, Ford, Nissan, Renault e Jeep, com 23 concessionárias distribuídas nos estados do Paraná e Santa Catarina.',
            'O Grupo Globo acredita em você cliente que preza por seriedade e segurança ao adquirir seu sonho, lhe proporcionando a certeza de um excelente atendimento, tendo por tradição o respeito ambiental, social e econômico nas cidades onde estamos localizados gerando empregos, eventos solidários mantendo uma equipe solida dedicada a você cliente.',
        ],
        link: 'https://www.grupoglobo.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupo.globo/',
        Facebook: 'https://www.facebook.com/ogrupoglobo',
        LinkedIn: 'https://www.linkedin.com/company/grupo-globo/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}